<template>
    <b-modal ref="modal" centered :title="$t('WARRANTY')" @close="close()" no-close-on-backdrop no-close-on-esc hide-footer>
        <div class="d-block mt-2">
          <div role="group" class="b-form-group form-group" v-if="formValues != null">
            <div v-if="globals.salesStaf != globals.groupId || (formValues.status == null ||  formValues.status != 'active')">
                <div class="form-row mb-lg">
                  <div class="col-sm-12">
                    <b-form-fieldset v-bind:label="$t('NAMEOFTEAMMEMBER')">
                      <inputvalidation :formerror="formError" name="name">
                        <b-form-input type="text" v-model="formValues.name"></b-form-input>
                      </inputvalidation>
                    </b-form-fieldset>
                  </div>
                </div>
                <div class="form-row mb-lg">
                  <div class="col-sm-12">
                    <b-form-fieldset v-bind:label="$t('RECEIPTTICKET')">
                      <inputvalidation :formerror="formError" name="receipt">
                        <b-form-input type="text" v-model="formValues.receipt"></b-form-input>
                      </inputvalidation>
                    </b-form-fieldset>
                  </div>
                </div>
                <div class="form-row mb-lg">
                  <div class="col-sm-12">
                    <b-form-fieldset v-bind:label="$t('DATEOFPURCHASE')">
                      <inputvalidation :formerror="formError" name="dateOfPurchase">
                        <lbdatepicker
                            type="date"
                            v-model="formValues.dateOfPurchase"
                            format="YYYY-MM-DD"
                            display-format="MM/DD/YYYY"
                            :simple="true">
                        </lbdatepicker>
                      </inputvalidation>
                    </b-form-fieldset>
                  </div>
                </div>
                <div class="form-row mb-lg">
                  <div class="col-sm-12">
                    <b-form-fieldset v-bind:label="$t('GUESTNAME')">
                      <inputvalidation :formerror="formError" name="guestInitial">
                        <b-form-input type="text" v-model="formValues.guestInitial"></b-form-input>
                      </inputvalidation>
                    </b-form-fieldset>
                  </div>
                </div>
                <div class="form-row mb-lg">
                  <div class="col-sm-12">
                    <b-form-fieldset v-bind:label="$t('GUESTPHONE')">
                      <inputvalidation :formerror="formError" name="phone">
                        <b-form-input type="text" v-model="formValues.phone"></b-form-input>
                      </inputvalidation>
                    </b-form-fieldset>
                  </div>
                </div>
                <div class="form-row mb-lg">
                  <div class="col-sm-12">
                    <b-form-fieldset v-bind:label="$t('BRAND')">
                      <inputvalidation :formerror="formError" name="brand">
                        <b-form-input type="text" v-model="formValues.brand"></b-form-input>
                      </inputvalidation>
                    </b-form-fieldset>
                  </div>
                </div>
                <div class="form-row mb-lg">
                  <div class="col-sm-12">
                    <b-form-fieldset v-bind:label="$t('NAMEOFPRODUCT')">
                      <inputvalidation :formerror="formError" name="nameOfProduct">
                        <b-form-input type="text" v-model="formValues.nameOfProduct"></b-form-input>
                      </inputvalidation>
                    </b-form-fieldset>
                  </div>
                </div>
                <div class="form-row mb-lg">
                  <div class="col-sm-12">
                    <b-form-fieldset v-bind:label="$t('COLOR')">
                      <inputvalidation :formerror="formError" name="color">
                        <b-form-input type="text" v-model="formValues.color"></b-form-input>
                      </inputvalidation>
                    </b-form-fieldset>
                  </div>
                </div>
                <div class="form-row mb-lg">
                  <div class="col-sm-12">
                    <b-form-fieldset v-bind:label="$t('SERVICEDETAILS')">
                      <inputvalidation :formerror="formError" name="detailOfWarranty">
                        <b-form-input type="text" v-model="formValues.detailOfWarranty"></b-form-input>
                      </inputvalidation>
                    </b-form-fieldset>
                  </div>
                </div>
                <div class="form-row mb-lg">
                  <div class="col-sm-12">
                    <b-form-fieldset v-bind:label="$t('SERVICEPREFERENCE')">
                      <inputvalidation :formerror="formError" name="preference">
                        <b-form-input type="text" v-model="formValues.preference"></b-form-input>
                      </inputvalidation>
                    </b-form-fieldset>
                  </div>
                </div>
                <div class="form-row mb-lg">
                  <div class="col-sm-12">
                    <b-form-fieldset v-bind:label="$t('WARRANTYCENTER')">
                      <inputvalidation :formerror="formError" name="warranty">
                        <b-form-input type="text" v-model="formValues.warranty"></b-form-input>
                      </inputvalidation>
                    </b-form-fieldset>
                  </div>
                </div>
                <div class="form-row mb-lg">
                  <div class="col-sm-12">
                    <b-form-fieldset v-bind:label="$t('IMAGE')">
                      <fileuploadnew v-model="formValues.imgSrc" :multiple="true" :chooseLabel="$t('SELECTFILE')" />
                    </b-form-fieldset>
                  </div>
                </div>
              </div>
              <div class="form-row mb-lg" v-if="formValues.status == 'active'
                || (globals.salesStaf != globals.groupId)">
                <div class="col-sm-12">
                  <b-form-fieldset v-bind:label="$t('TRACKING')">
                    <inputvalidation :formerror="formError" name="tracking">
                      <b-form-input type="text" v-model="formValues.tracking"></b-form-input>
                    </inputvalidation>
                  </b-form-fieldset>
                </div>
              </div>
              <div class="form-row mb-lg" v-if="(globals.salesStaf != globals.groupId && globals.storeManager != globals.groupId) && (formValues.status == 'prepared' || formValues.status == 'active')">
                <div class="col-sm-12">
                  <b-form-fieldset v-bind:label="$t('ISACCEBTABLE')">
                    <b-form-checkbox :plain="true" v-model="formValues.status" value="active">{{$t('ISACCEBTABLE')}}</b-form-checkbox>
                  </b-form-fieldset>
                </div>
              </div>
              <div class="form-row mb-lg" v-if="(globals.salesStaf != globals.groupId && globals.storeManager != globals.groupId) && (formValues.status == 'pending' || formValues.status == 'finished')">
                <div class="col-sm-12">
                  <b-form-fieldset v-bind:label="$t('ISITFINISHED')">
                    <b-form-checkbox :plain="true" v-model="formValues.status" value="finished">{{$t('ISFINISHED')}}</b-form-checkbox>
                  </b-form-fieldset>
                </div>
              </div>               
            </div>
          </div>

          <div class="text-right">
              <b-btn variant="secondary-trans mr-4" @click="close()">{{$t('CANCEL')}}</b-btn>
              <b-btn variant="primary" @click="submitData(formValues)">{{$t('SAVE')}}</b-btn>
          </div>
    </b-modal>
</template>

<script>
import
{
    mapGetters,
}
    from 'vuex';    
import Api from '@/api/warranty/Warranty.js';

export default
{
    name: 'WarrantyForm',
    props: ['value'],
    data()
    {
        const me = this;

        return {
            formError: {},
            formValues: null,
            formData: null,
        };
    },
    methods:
    {
        async getData(warrantyId)
        {
          const me = this;
          try 
          {
            me.loading = true;
            const data = await Api.selectRowById({id: warrantyId});
            if (data.error && data.error === true)
            {
              throw (data);
            }
            me.formValues = data.root;
          } 
          catch (error) 
          {
            console.log(error);
            me.$notify.notice(error);
          } 
          finally
          {
            me.loading = false;
          }
        },
        async submitData(item)
        {
            const me = this;
            try
            {
                if (typeof item.warrantyId !== 'undefined')
                {
                    item.id = item.warrantyId;
                    delete (item.warrantyId);
                }

                if (item.imgSrc != null && item.imgSrc != '' && typeof item.imgSrc != 'string')
                {
                    item.imgSrc = item.imgSrc.join(',');
                }
                
                const data = await Api.submitData(item);
                me.$notify.notice(data);

                if (data.error)
                {
                    me.formError = data;
                }
                else
                {
                    me.close();
                }
            }
            catch (e)
            {
                console.log(e);
                me.$notify.notice(e);
            }
        },
        close()
        {
            const me = this;
            me.formData = null;
            me.formValues = null;
            me.formError = {};
            me.$emit('close');
        },
    },
    watch:
    {
        async formData(val)
        {
            const me = this;
            if (val != null)
            {
                if (val.warrantyId != null)
                {
                    await me.getData(val.warrantyId);
                }
                else
                {
                    me.formValues = { ...val };
                }
                me.$refs.modal.show();
            }
            else
            {
                me.$refs.modal.hide();
            }
        },
        value(val)
        {
            const me = this;
            if (val != null)
            {
                me.formData = { ...val };
            }
            else
            {
                me.formData = null;
                me.formValues = null;
            }
        },
    },
    computed:
    {
        ...mapGetters([
            'globals',
        ]),
    },
};
</script>
